import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { ListingCardSkeleton } from '@/components/Skeletons/ListingCardSkeleton';

export default function SkeletonState({ numPerPage }: { numPerPage: number }): JSX.Element {
  const firstPage = Array(numPerPage).fill(0);

  return (
    <Stack position="relative" direction="row" alignItems="center">
      <Box overflow="auto" display={{ smallTablet: 'none' }}>
        <Stack
          width={(firstPage.length + 1) * (numPerPage === 4 ? 280 : 226)}
          direction="row"
          gap={2}
        >
          {firstPage.map((_, index) => (
            <Box
              width={numPerPage === 4 ? 280 : 226}
              key={index}
              data-testid={`skeleton-card-${index}`}
            >
              <ListingCardSkeleton />
            </Box>
          ))}
        </Stack>
      </Box>
      <Stack
        overflow="auto"
        flex={1}
        position="relative"
        display={{ mobile: 'none', smallTablet: 'block' }}
      >
        <Stack direction="row" gap={5}>
          {firstPage.map((_, index) => (
            <ListingCardSkeleton key={index} />
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
}
